/**
 * Props for StyleRenderer component
 */
export interface StyleRendererProps {
	/** Pre-generated CSS string to render */
	css: string;
	/** Unique block identifier */
	blockId: string;
	/** Children to render */
	children?: React.ReactNode;
}
